import { SocialLinks } from "@/components/social-links";
import { catalogUrlLabel } from "@/lib/catalog-url-label";
import type { CatalogUrl, SocialLink } from "@garimpa/lib/musicTypes";

function Divider() {
  return <span aria-hidden="true" className="mx-1 h-5 w-px shrink-0 bg-border" />;
}

/** Social icons and official sites for the hero actions row. */
export function EntityQuickLinks({
  officialUrls,
  socialUrls,
}: {
  officialUrls: CatalogUrl[];
  socialUrls: SocialLink[];
}) {
  return (
    <>
      {socialUrls.length > 0 && (
        <>
          <Divider />
          <SocialLinks links={socialUrls} className="my-0 shrink-0" />
        </>
      )}
      {officialUrls.length > 0 && <Divider />}
      {officialUrls.map((link) => (
        <a
          key={link.url}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          title={link.type}
          className="shrink-0 text-sm font-semibold text-primary hover:underline"
        >
          {catalogUrlLabel(link.url)}
        </a>
      ))}
    </>
  );
}
